import { Fill, Stroke, Style } from 'ol/style'
import Geometry from '@/orrm/Geometry'
import Link from '@/orrm/Link'
import { ToOneRelation } from 'coloquent/dist/relation/ToOneRelation'
import { EntityType } from '@/orrm/model/entity-type'
import { Builder } from 'coloquent'
import { StyleFunction } from 'ol/style/Style'
import Feature, { FeatureLike } from 'ol/Feature'
import { centroidsResource } from '@/api'
import AbstractClusterableNode from '@/orrm/model/AbstractClusterableNode'

export class Entity extends AbstractClusterableNode {
  protected jsonApiType = 'node/orrm_entite_cartographique'
  protected static pageSize = 125
  public static readonly searchField = 'title'
  public static readonly layerId = 'entities'
  public static readonly centroidsResourceGetter = centroidsResource.getEntitesCentroids

  public static readonly featureStyle = new Style({
    stroke: new Stroke({
      color: '#2196F3',
      width: 1
    }),
    fill: new Fill({
      color: 'rgba(33, 150, 243, .2)'
    })
  })

  public static readonly clusterFeatureStyle: StyleFunction = Entity.clusterFeatureStyleFactory({
    stroke: Entity.featureStyle.getStroke(),
    fill: new Fill({
      color: 'rgba(33, 150, 243, .5)'
    })
  })

  public static readonly featureStyleFunction: StyleFunction = (feature: FeatureLike, resolution: number) => {
    const maxTolerence = 700
    let style = Entity.featureStyle

    if (feature instanceof Feature) {
      const tolerence = (resolution || maxTolerence) > maxTolerence ? maxTolerence : (resolution || maxTolerence)
      style.setGeometry(feature.getGeometry()!.simplify(tolerence))

      if (feature.get('focus')) {
        style = Entity.focusFeatureStyle
      }
    }
    return style
  }

  public static readonly focusFeatureStyle = new Style({
    stroke: new Stroke({
      color: '#2196F3',
      width: 2
    }),
    fill: new Fill({
      color: 'rgba(33, 150, 243, .4)'
    })
  })

  static getQueryBuilder (): Builder<Entity> {
    return Entity
      .with('field_orrm_type_entite') as Builder<Entity>
  }

  get title (): string {
    return this.getAttribute('title')
  }

  get link (): Link {
    return this.getAttribute('field_orrm_lien')
  }

  get geometry (): Geometry | null {
    return this.getAttribute('field_orrm_geometrie')
  }

  field_orrm_type_entite (): ToOneRelation<EntityType, this> { // eslint-disable-line
    return this.hasOne(EntityType)
  }

  getEntityType (): EntityType {
    return this.getRelation('field_orrm_type_entite')
  }
}
